import { useRef, useState } from "react";
import { useDrag, useDrop } from "react-dnd";
import { TreeItem } from "@mui/x-tree-view";
import Divider from "@mui/material/Divider";
import { useViewState } from "../model/ViewState";
import { observer } from "mobx-react";
import { useProjectStore } from "../model/ProjectStore";

const TreeItemTask = ({ task, moveTask }) => {
  const project = useProjectStore();
  const view = useViewState();
  const [location, setLocation] = useState("bottom");
  const ref = useRef(null);
  const currentType = "task";

  const [{ isDragging }, drag] = useDrag({
    type: "task",
    item: () => {
      return {
        id: task.displayIndex,
        location: "bottom",
      }
    },
    end: (item, monitor) => {
      const type = monitor.getDropResult();
      if (type === null || monitor.getItem() === null) {
        return;
      }
      const hover =
        type.dropType === "package"
          ? monitor.getItem().idPack
          : monitor.getItem().id;
      const location =
        type.dropType === "package"
          ? monitor.getItem().locationPack
          : monitor.getItem().location;

      return moveTask(
        task.displayIndex,
        hover,
        location,
        type.dropType
      );
    },
    collect: (monitor) => {
      return {
        isDragging: !!monitor.isDragging()
      }
    }
  });

  const [{ isOverCurrent }, drop] = useDrop({
    accept: "task",
    hover: (item, monitor) => {
      const hoverBoundingRect = ref.current.getBoundingClientRect();

      const hoverBoxHeight = hoverBoundingRect.bottom - hoverBoundingRect.top;
      const middleStart = hoverBoxHeight / 2;
      const clientOffset = monitor.getClientOffset();
      const distTop = clientOffset.y - hoverBoundingRect.top;

      // insertAbove
      if (location !== "top" && distTop <= middleStart) {
        monitor.getItem().id = task.displayIndex;
        monitor.getItem().location = "top";
        setLocation("top");
      }

      // insertBelow
      else if (location !== "bottom" && distTop > middleStart) {
        monitor.getItem().id = task.displayIndex;
        monitor.getItem().location = "bottom";
        setLocation("bottom");
      }
    },
    drop: (item, monitor) => {
      return {
        dropType: currentType,
      };
    },
    collect: (monitor) => {
      return {
        isOverCurrent: !!monitor.isOver({ shallow: false })
      }
    }
  });

  const opacity = isDragging ? 0 : 1;

  const paddingTop =
    isOverCurrent && location === "top" ? (
      <Divider style={{ background: "black" }} />
    ) : (
      <div />
    );

  const paddingBottom =
    isOverCurrent && location === "bottom" ? (
      <Divider style={{ background: "black" }} />
    ) : (
      <div />
    );

  const handleItemClick = (event) => {
    event.stopPropagation();
    view.setSelectedTaskId(task.id)
    view.setSelectedTaskIndex(project.rootTaskPackage.getDisplayIndex(task.id))
  }

  return (
    <div ref={(node) => { ref.current = node; drag(drop(node)) }}>
      {paddingTop}
      <TreeItem
        // style={{ opacity, background: "white" }}
        itemId={task.id}
        label={task.code + "\t" + task.name}
        onClick={handleItemClick}
      />
      {paddingBottom}
    </div>
  );
};

export default observer(TreeItemTask);